require('../../modules/es6.reflect.has');
module.exports = require('../../modules/_core').Reflect.has;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/reflect/has.js
// module id = 799
// module chunks = 2